import { useRef } from 'react';

export function useHotRef<V>(value: V) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
